<template>
  <div>
    <!-- Conditionally render Navbar based on login state -->
    <div id="navigation" v-if="authStore.loggedIn">
      <Navbar />
    </div>

    <!-- Main container for the app -->
    <div :class="{ container: !noContainer }">
      <Suspense>
        <router-view />

        <template #fallback>
          Loading...
        </template>
      </Suspense>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Navbar from './components/Navbar.vue';
import { useAuthStore } from './stores/authStore';

// Use the auth store
const authStore = useAuthStore();

// Use the current route to compute whether a container is needed
const route = useRoute();
const noContainer = computed(() => route.query.no_container === 'true');
</script>

<style>
/* Styles for the app */
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.container {
  padding: 1rem;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #80acff;
}

#navigation {
  margin-bottom: 1em;
}
</style>